<template>
  <div class="row">
    <div class="col-md-12">
      <div class="shadow p-3 mb-3 bg-white rounded">
        <h5>Report Options</h5>
        <div class="mb-2">
          <button class="btn btn-secondary btn-block pa-1 mr-2">
            CREATE REPORT
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="shadow p-3 mb-3 bg-white rounded filter">
        <h5>Filter Result</h5>
        <form action="">
          <div class="form-group">
            <select class="form-control">
              <option value="">All Channels</option>
            </select>
          </div>
          <div class="form-group">
            <select class="form-control">
              <option value="">Last 14 days</option>
            </select>
          </div>
          <div class="form-group">
            <vue-tags-input
              v-model="tag"
              :tags="tags"
              placeholder="All Listing"
              @tags-changed="(newTags) => (tags = newTags)"
            />
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-4 text-center">Start date</div>
            <div class="col-lg-8">
              <input type="date" class="form-control" />
            </div>
          </div>
          <div class="form-group row align-items-center">
            <div class="col-lg-4 text-center">End date</div>
            <div class="col-lg-8">
              <input type="date" class="form-control" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-apply btn-block py-1" @click="onSearch">
                <span></span>
                <span>APPLY</span>
                <i class="fas fa-check"></i>
              </button>
            </div>
            <div class="col-md-6">
              <button class="btn btn-reset btn-block py-1" @click="onReset">
                <span></span>
                <span>RESET FILTERS</span>
                <i class="fas fa-redo"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
export default {
  components: {
    VueTagsInput,
  },
  data() {
    return {
      search: "",
      types: [],
      sort: "CREATED_AT",
      tag: '',
      tags: [],
    };
  },
  methods: {
    onAdd(type) {
      this.$emit("onAdd", type);
    },
    onClickChangeStatus(status) {
      this.$emit("onClickChangeStatus", status);
    },
    onSearch() {
      const data = {
        search: this.search,
        types: this.types,
        sort: this.sort,
      };
      this.$emit("search", data);
    },
    onReset() {
      this.search = "";
      this.types = [];
      this.btn.experience = false;
      this.btn.tour = false;
      this.btn.event = false;
      this.btn.story = false;
    },
    addTypes(type) {
      const index = this.types.indexOf(type);
      if (index > -1) {
        this.types.splice(index, 1);
      } else {
        this.types.push(type);
      }

      if (type == "experience") {
        this.btn.experience = !this.btn.experience;
      }

      if (type == "tour") {
        this.btn.tour = !this.btn.tour;
      }

      if (type == "event") {
        this.btn.event = !this.btn.event;
      }

      if (type == "story") {
        this.btn.story = !this.btn.story;
      }
    },
  },
};
</script>

<style lang="scss">
h5 {
  color: var(--primary-color);
}
.filter {
  .btn {
    color: #fff;
    border-radius: 19px;
    text-transform: none;

    &.btn-status {
      background-color: var(--primary-color);
    }
    &.btn-experiences {
      background-color: #1da1f2;
    }
    &.btn-tours {
      background-color: #c32aa3;
    }
    &.btn-events {
      background-color: #bd081c;
    }
    &.btn-stories {
      background-color: #1877f2;
    }

    &.btn-apply {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--primary-color);
    }

    &.btn-reset {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #58595b;
    }

    &:hover {
      background-color: #58595b;
    }

    &.active {
      background-color: #58595b;
    }
  }

  input {
    &.form-control {
      border: 1px solid #b9b9b9;
      border-radius: 0;
    }
  }

  select {
    &.form-control {
      border-radius: 0;
      background-image: url("../../../assets/images/select-style.jpg");
      background-repeat: no-repeat, repeat;
      background-position: right 0 top 50%, 0 0;
      padding-right: 39px;
    }
  }

  .vue-tags-input {
    max-width: initial !important;

    .ti-input {
      min-height: 150px;
    }

    .ti-tags {
      align-items: flex-start;
    }

    .ti-tag {
      border-radius: 15px;
      padding: 5px 10px;
    }

    .ti-tag,
    .ti-selected-item {
      background-color: var(--primary-color);
      color: white;
    }

    .ti-autocomplete {
      color: black;
    }
  }
}
</style>